export const getFileNameFromContentDisposition = (disposition) => {
  const utf8FilenameRegex = /filename\*=UTF-8''([\w%\-\.]+)(?:; ?|$)/i;
  const asciiFilenameRegex = /filename=(["']?)(.*?[^\\])\1(?:; ?|$)/i;

  let fileName = null;
  if (utf8FilenameRegex.test(disposition)) {
    fileName = decodeURIComponent(utf8FilenameRegex.exec(disposition)[1]);
  } else {
    const matches = asciiFilenameRegex.exec(disposition);
    if (matches != null && matches[2]) {
      fileName = matches[2];
    }
  }
  return fileName;
};

//Request might be including sensitive information like authentication
//Therefore there is hideRequest option to exclude request.
export const loadResponse = (request, response, hideRequest = false) => {
  return {
    response,
    ...(!!!hideRequest && { request })
  };
};

export const loadSpfResponse = (request, response) => {
  const responseData = response.results;
  delete response.results;

  return {
    request,
    response: {
      parameters: {
        ...response,
        total: response.filteredRecordCount,
        current: response.currentPage,
        hasMore: response.totalPageCount > response.currentPage
      },
      data: responseData
    }
  };
};

export const loadError = (request, response, hideRequest = false) => {
  return {
    response: {
      error: response.errorMessage
    },
    ...(!!!hideRequest && { request })
  };
};
